export default function Date({ response, setResponse, name, disabled = false, className = '' }) {
  const handleChange = (event) => {
    setResponse(event.target.value);
  }

  return (
    <div className={`answers grow ${className}`}>
      <input
        type="date"
        onChange={handleChange}
        disabled={disabled}
        value={response || ''}
      />
    </div>
  )
}

